module.exports = __webpack_public_path__ + "media/2.54aa3af7.mp3";